// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadPlaceholder_wrapper__QFGmo","inner":"UploadPlaceholder_inner__-51eC"};